import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DateTime } from "luxon";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  constructor(private http: HttpClient) {}

  downloadFile(
    data: Blob,
    filename: string = `arquivo_${DateTime.local().toFormat("yyyyMMdd")}.xlsx`
  ) {
    const newBlob = new Blob([data], { type: "application/vnd.ms-excel" });

    // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //   window.navigator.msSaveOrOpenBlob(newBlob);
    //   return;
    // }

    const linkData = window.URL.createObjectURL(newBlob);
    const link = document.createElement("a");

    link.href = linkData;
    link.download = filename;

    link.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
    );

    setTimeout(function () {
      window.URL.revokeObjectURL(linkData);
      link.remove();
    }, 100);
  }
}
